<template>
    <div class="container">
        <div class="row">
            <template v-for="project of cleanProjects">
                <div class="visible-sm-block visible-md-block visible-lg-block clearfix"
                     v-if="!($index % 3) && $index"></div>

                <div class="col-sm-4">
                    <div class="panel panel-info">
                        <div class="panel-heading">
                            {{ project.project_name }}
                        </div>
                        <div class="panel-body">
                            <ul>
                                <li v-for="info of project.attrs">
                                    <strong>{{ infoTitle(info.slug) }}</strong>
                                    {{{ formatInfo(info) }}}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <div class="row cta-row">
            <loader v-if="loading"
                    :inline="true"></loader>
            <a href="#"
               @click.prevent="updateList(true)"
               v-if="!loading && hasNext"
               class="btn btn-primary">
                Charger plus
            </a>
        </div>
    </div>
</template>

<style type="text/css"
       scoped>
    .cta-row {
        text-align: center;
        margin: 20px 0;
    }
</style>

<script type="text/ecmascript-6">
    import {makeUpdateList} from '../../utils';
    import {infoTitle, formatInfo} from '../../api/todo';
    import {list as listProjects} from '../../api/projects';
    import Loader from '../../components/Loader';

    export default {
        components: {
            Loader
        },
        props: {
            client: {
                'default': () => ({})
            }
        },
        data() {
            return {
                projects: [],
                loading: false,
                page: 1,
                hasNext: false
            };
        },
        computed: {
            cleanProjects() {
                return this.projects.map((x) => ({
                    project_name: x.project_name,
                    attrs: this.cleanProject(x)
                }));
            }
        },
        methods: {
            infoTitle,
            formatInfo,
            updateList: makeUpdateList({
                loading: 'loading',
                page: 'page',
                hasNext: 'hasNext',
                list: 'projects',
                fetch: async function (page) {
                    return await listProjects(this.client.id, page);
                }
            }),
            cleanProject(proj) {
                const out = [];
                const keys = [
                    'project_type',
                    'fiscal_framework',
                    'village',
                    'duration',
                    'invested_capital',
                    'monthly_investment',
                    'target_capital',
                    'life_plan'
                ];

                for (const k of keys) {
                    const v = proj[k];
                    if (v) {
                        out.push({
                            slug: k,
                            value: v
                        });
                    }
                }

                return out;
            }
        },
        ready() {
            this.updateList();
        }
    };
</script>



// WEBPACK FOOTER //
// AsProjectsTab.vue?c77d2402